import BaseAuthAPI from '../flynk.app.web.core.data/api/AuthAPI'

export default class AuthAPI extends BaseAuthAPI {
  getContext = () => this.request.get('/Users/GetCurrentUserContext')
}
